import React from 'react';

function ECGForm() {
  return (
    <div>
      <h2>ECGForm</h2>
    </div>
  );
}

export default ECGForm;
